import addMinutes from 'date-fns/addMinutes';
import axios from 'axios';
import { doLogin, doLoginGS, doLoginUnifi, doTournaments } from '@/utils/api/login';
import token from '@/data/user/token';
const nationalTournaments = [1, 2, 1071, 1093, 43, 44, 1095, 191, 192, 1096, 197, 1001, 1038];

// Time To Live minutes for the user's session. 120 minutes = 2 hours.
const TTL = 120;
const state = {
  booleanIsGSBehavior: true,
  user: {
    id: 32544,
    player: 0,
    show_dashboard: 0,
    token_b2c: token.free,
    tournament: 1,
    season: 1694,
    premiumAccount: false,
    userType: 0, //0, b2c - 1 gol
    accessVideos: false,
    active_time: 0, //0: no activo - 1: activo
    language: 'es',
  },
  currentLanguage: 'es',
  // premium: true,
  modal: false,
  urlGS1: '',
  isGS1: false,
  isGS1Account: '',
  is3pv: false,
  tournaments: {},
  seasons: {},
  tournamentSelected: null,
  seasonSelected: null,
  pymErr: false,
  tournamentNameSelected: '',
  seasonNameSelected: '',
  seasonsByRegularSeason: new Map(),
  tournamentsForMediaPlayer: new Map(),
  opened: false,
  mapTournaments: new Map(),
  booleanIsFromMexico: false,
  arrayTournamentsRaw: [],
};

const mutations = {
  setArrayTournamentsRaw(state, arrayTournamentsRaw) {
    state.arrayTournamentsRaw = arrayTournamentsRaw;
  },
  setBooleanIsFromMexico(state, booleanIsFromMexico) {
    state.booleanIsFromMexico = booleanIsFromMexico;
  },
  setOpened(state, val) {
    state.opened = val;
  },
  setUser(state, user) {
    state.user = user;
    if (user) {
      axios.defaults.headers.common['Authorization'] = user.token_b2c;
    } else {
      axios.defaults.headers.common['Authorization'] = '';
    }
  },
  setURL(state, url) {
    state.urlGS1 = url;
  },
  setCurrentLanguage(state, language) {
    state.currentLanguage = language;
  },
  setModal(state, val) {
    state.modal = val;
  },
  setTournaments(state, tournaments) {
    state.tournaments = tournaments;
  },
  setSeasons(state, seasons) {
    state.seasons = seasons;
  },
  setTournamentsSelected(state, tournament) {
    state.tournamentSelected = Number(tournament);
    window.localStorage.setItem('tournamentSelected', tournament);
  },
  setPymErr(state, pymErr) {
    state.pymErr = pymErr;
  },
  setSeasonsSelected(state, season) {
    state.seasonSelected = Number(season);
    window.localStorage.setItem('seasonSelected', season);
  },
  setTournamentsNameSelected(state, tournament) {
    state.tournamentNameSelected = tournament;
  },
  setSeasonsNameSelected(state, season) {
    state.seasonNameSelected = season;
  },
  setSeasonsByRegularSeason(state, seasonsByRegularSeason) {
    state.seasonsByRegularSeason = seasonsByRegularSeason;
  },
  setTournamentsForMediaPlayer(state, tournamentsForMediaPlayer) {
    state.tournamentsForMediaPlayer = tournamentsForMediaPlayer;
  },
  setMapTournaments(state, mapTournaments) {
    state.mapTournaments = mapTournaments;
  },
};

const actions = {
  /**
   * @author Alejandro
   * @param {Object} context
   * @param {Object} params
   * @param {Object=} params.user
   * @param {string} params.user.username
   * @param {string} params.user.password
   * @param {number=} params.user.season
   * @param {string=} params.encodedUser
   * @return {Promise<boolean>}
   */
  async doLoginUnifi({ dispatch, commit }, params) {
    // let isLoggedInGS2 = false;
    try {
      // if (typeof params.loggedInGS2 !== 'undefined') {
      //   isLoggedInGS2 = params.loggedInGS2;
      // }
      const result = await doLoginUnifi(params.form);
      const loginData = result.data;
      if (loginData.login_type === 2) {
        //b2c
        await dispatch('prepareStoreUserInfoLocal', result.data);
        const ALERT = {
          type: 'info',
          message: 'Se ha iniciado correctamente la sesi&oacute;n.',
        };
        await dispatch('alertGeneral/setAlert', ALERT, { root: true });
      }
      if (loginData.login_type === 1) {
        const gs2LoginData = {
          username: params.form.user,
          password: params.form.password,
        };
        dispatch('storeUrlProfessional', gs2LoginData);
        const ALERT = {
          type: 'info',
          message: 'Se ha iniciado correctamente la sesi&oacute;n.',
        };
        await dispatch('alertGeneral/setAlert', ALERT, { root: true });
      }
      return loginData;
    } catch (e) {
      const ALERT = {
        type: 'error',
        message: 'Credenciales incorrectas',
      };
      dispatch('alertGeneral/setAlert', ALERT, { root: true });
      setTimeout(() => {
        commit('SET_AUTH_COMPONENT', null, { root: true });
        commit('setIsSectionLoading', false, { root: true });
      }, 1000);

      return false;
    }
  },
  async doLogin({ dispatch }, params) {
    // console.log('ESTAMOS EN FUNCION INTERNA DOLOGIN');
    // try {
    //   let userData = params.encodedUser ? JSON.parse(window.atob(params.encodedUser)) : params.user;
    //   const result = await doLogin(userData);
    //   dispatch('storeUserInfoLocal', result.data);
    //   // console.log('LLEGO ACA LLEGO ACA LLEGO 99999999999999999999');
    //   dispatch('storeUrlProfessional', userData);
    //   return true;
    // } catch (e) {
    //   return Promise.reject(e);
    // }
    let isLoggedInGS2 = false;
    try {
      if (typeof params.loggedInGS2 !== 'undefined') {
        isLoggedInGS2 = params.loggedInGS2;
      }
      const result = await doLogin(params.form);
      const loginData = result.data;
      if (![1, 4].includes(loginData.user_type)) {
        await dispatch('prepareStoreUserInfoLocal', result.data);
        const ALERT = {
          type: 'info',
          message: 'Se ha iniciado correctamente la sesi&oacute;n.',
        };
        await dispatch('alertGeneral/setAlert', ALERT, { root: true });
      }
      return loginData;
    } catch (e) {
      if (!isLoggedInGS2) {
        const ALERT = {
          type: 'error',
          message: e.response.data.message,
        };
        dispatch('alertGeneral/setAlert', ALERT, { root: true });
      }
      return false;
    }
  },
  async loginPostRegister({ dispatch, commit }, data) {
    await commit('setIsSectionLoading', true, { root: true });

    var USER = {
      id: 32544,
      name: data.name,
      player: 0,
      token: data.token,
      token_b2c: data.token,
      show_dashboard: 1,
      tournament: 1,
      provider: data.provider,
      golstats: data.user_type,
      userType: 0,
      accessVideos: true,
      season: 1694,
      active_time: 0,
      language: 'es',
      // todo: change true to Premium_account variable
      premiumAccount: true,
      sessionExpiration: addMinutes(new Date(), TTL).getTime(),
      isB2CUser: false,
    };
    await dispatch('storeUserInfoLocal', USER);
    await commit('SET_AUTH_COMPONENT', null, { root: true });
    await commit('setIsSectionLoading', false, { root: true });
  },
  prepareStoreUserInfoLocal({ dispatch, commit }, data) {
    var USER = {};
    if (data.hasOwnProperty('show_dashboard') && data.hasOwnProperty('tournament')) {
      USER = data;
      USER.premiumAccount = true;
      USER.userType = 1;
      USER.accessVideos = true;
    } else {
      const INFO = data.account_name.split('_');
      const USER_NAME = INFO[0];
      const DATE = INFO.slice(-1)[0];
      const TODAY = new Date();
      const YEAR = TODAY.getFullYear().toString();
      const PREMIUM_ACCOUNT = DATE.length === 6 || DATE.search(YEAR) === 0;
      USER = {
        id: data.id,
        name: USER_NAME,
        player: 0,
        token: data.token,
        token_b2c: data.token,
        show_dashboard: 1,
        tournament: 1,
        provider: data.provider,
        golstats: data.user_type,
        userType: 0,
        accessVideos: true,
        season: 1694,
        active_time: 0,
        language: 'es',
        // todo: change true to Premium_account variable
        premiumAccount: PREMIUM_ACCOUNT,
        sessionExpiration: addMinutes(new Date(), TTL).getTime(),
        isB2CUser: DATE.length === 8,
      };
    }
    // console.log('SET URSER: USER:');
    // console.log(USER);

    if (data.pym_err === 1) commit('setPymErr', true);
    dispatch('storeUserInfoLocal', USER);
  },
  /**
   * @author Alejandro
   * @param {Object} context
   * @param {Object} params
   * @param {string} params.userEncoded
   * @param {string} params.login.user
   * @param {string} params.login.password
   * @return {Promise<boolean>}
   */
  async doLoginGS2({ dispatch, commit }, params) {
    try {
      const objectLoginData = state.booleanIsGSBehavior ? params.user : params.login;
      const response = await doLoginGS(objectLoginData);
      dispatch('storeUrlProfessional', objectLoginData);
      const ALERT = {
        type: 'info',
        message: 'Se ha iniciado correctamente la sesi&oacute;n.',
      };
      await dispatch('alertGeneral/setAlert', ALERT, { root: true });
      // await commit('setIsGS1', { val: true, data: params.login, type: 1 });
      // state.isGS1Account = params.name;
      // window.localStorage.setItem('gs2User', params.userEncoded);
      // window.localStorage.setItem('isGS1Account', params.login.user);
      // await dispatch('prepareStoreUserInfoLocal', response.data);
      return response.data;
    } catch (e) {
      const ALERT = {
        type: 'error',
        message: 'Credenciales incorrectas',
      };
      dispatch('alertGeneral/setAlert', ALERT, { root: true });
      setTimeout(() => {
        commit('SET_AUTH_COMPONENT', null, { root: true });
        commit('setIsSectionLoading', false, { root: true });
      }, 1000);

      return Promise.reject(e);
    }
  },
  async storeTournamentSelected({ commit }, tournament) {
    commit('setTournamentsSelected', tournament);
  },
  async storeSeasonSelected({ commit }, season) {
    commit('setSeasonsSelected', season);
  },
  async storeTournamentNameSelected({ commit }, tournament) {
    commit('setTournamentsNameSelected', tournament);
  },
  async storeSeasonNameSelected({ commit }, season) {
    commit('setSeasonsNameSelected', season);
  },

  async storeTournaments({ state, commit }) {
    if (!state.arrayTournamentsRaw.length) {
      const dataTournament = await doTournaments();
      const seasonsByRegularSeason = new Map();
      const tournamentsForMediaPlayer = new Map();
      let data = [...dataTournament.data];
      let arrayTournaments = {};
      let arraySeasons = {};
      const mapTournaments = new Map();
      commit('setArrayTournamentsRaw', dataTournament.data || []);
      for (const indexTournament in data) {
        const objectTournament = data[indexTournament];
        mapTournaments.set(objectTournament._id, {
          ...objectTournament.tournament,
          arraySeasons: objectTournament.seasons,
        });
        arrayTournaments[data[indexTournament].tournament.id] = {};
        arrayTournaments[data[indexTournament].tournament.id]['id'] = data[indexTournament].tournament.id;
        arrayTournaments[data[indexTournament].tournament.id]['name'] = data[indexTournament].tournament.name;
        arraySeasons[data[indexTournament].tournament.id] = {};
        for (const indexSeason in data[indexTournament].seasons) {
          const regularSeason = data[indexTournament].seasons[indexSeason];
          const seasonsArray = [{ id: regularSeason.id, type: regularSeason.type }];
          for (const relatedSeason of regularSeason.related_seasons) {
            seasonsArray.push({ id: relatedSeason.id, type: relatedSeason.type });
          }
          seasonsByRegularSeason.set(regularSeason.id, seasonsArray);
          tournamentsForMediaPlayer.set(regularSeason.id, data[indexTournament]);
          arraySeasons[data[indexTournament].tournament.id][' ' + data[indexTournament].seasons[indexSeason].id] = {};
          arraySeasons[data[indexTournament].tournament.id][' ' + data[indexTournament].seasons[indexSeason].id]['id'] =
            data[indexTournament].seasons[indexSeason].id;
          arraySeasons[data[indexTournament].tournament.id][' ' + data[indexTournament].seasons[indexSeason].id][
            'name'
          ] = data[indexTournament].seasons[indexSeason].name;
        }
      }
      commit('setMapTournaments', mapTournaments);
      commit('setTournamentsForMediaPlayer', tournamentsForMediaPlayer);
      commit('setSeasonsByRegularSeason', seasonsByRegularSeason);
      commit('setTournaments', arrayTournaments);
      commit('setSeasons', arraySeasons);
      if (localStorage.getItem('seasonSelected') === null || localStorage.getItem('seasonSelected') === 'undefined') {
        const nowMillis = new Date().getTime();
        const qatarEnabledDayMillis = new Date('2022-11-21T03:59:00.000Z').getTime();
        const cupFinalDayMillis = new Date('2022-12-18T23:59:59.000Z').getTime();
        if (nowMillis < cupFinalDayMillis && state.user.type_system == 'seleccion' && !state.user.show_dashboard) {
          commit('setTournamentsSelected', arrayTournaments[33].id);
          commit(
            'setSeasonsSelected',
            Object.keys(arraySeasons[arrayTournaments[33].id])[nowMillis >= qatarEnabledDayMillis ? 0 : 1].slice(1),
          );
          commit('setTournamentsNameSelected', arrayTournaments[33].name);
          commit(
            'setSeasonsNameSelected',
            arraySeasons[arrayTournaments[33].id][
              Object.keys(arraySeasons[arrayTournaments[33].id])[nowMillis >= qatarEnabledDayMillis ? 0 : 1]
            ].name,
          );
        } else {
          // console.log('Este es el caso de que no haya nada en el local storage');
          var defaultTournament = {};
          if (state.user !== null) {
            // console.log(111111111);
            defaultTournament = arrayTournaments[`${state.user.tournament}`] || arrayTournaments['1'];
          } else {
            // console.log(222222);
            defaultTournament = arrayTournaments['1'];
          }
          commit('setTournamentsSelected', defaultTournament.id);
          commit('setSeasonsSelected', Object.keys(arraySeasons[defaultTournament.id])[0].slice(1));
          commit('setTournamentsNameSelected', defaultTournament.name);
          commit(
            'setSeasonsNameSelected',
            arraySeasons[defaultTournament.id][Object.keys(arraySeasons[defaultTournament.id])[0]].name,
          );
        }
      } else {
        commit('setTournamentsSelected', localStorage.getItem('tournamentSelected'));
        commit('setSeasonsSelected', localStorage.getItem('seasonSelected'));
        commit('setTournamentsNameSelected', arrayTournaments[localStorage.getItem('tournamentSelected')].name);
        commit(
          'setSeasonsNameSelected',
          arraySeasons[localStorage.getItem('tournamentSelected')][' ' + localStorage.getItem('seasonSelected')].name,
        );
      }
    }
  },

  storeUrlProfessional({ commit }, user) {
    let userCode = Buffer.from(user.username).toString('base64');
    let passCode = Buffer.from(user.password).toString('base64');
    window.localStorage.setItem('urlGS1', 'https://professional-v1.golstats.com/loginGS2/' + userCode + '/' + passCode);
    let urlGS1 = 'https://professional-v1.golstats.com/loginGS2/' + userCode + '/' + passCode;
    commit('setURL', urlGS1);
  },
  storeOpened({ commit }, val) {
    commit('setOpened', val);
  },
  storeUserInfoLocal({ state, commit }, user) {
    if (user) user.sessionExpiration = addMinutes(new Date(), TTL).getTime();
    window.localStorage.setItem('user', window.btoa(JSON.stringify(user)));
    commit('setUser', user);

    if (
      user &&
      user.language &&
      process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',').includes(user.language) &&
      state.currentLanguage !== user.language
    ) {
      commit('setCurrentLanguage', user.language);
    }
  },
  async updateUserSessionExpiration({ dispatch }) {
    const user = await dispatch('getUserInfoLocal');
    if (user) {
      dispatch('storeUserInfoLocal', user);
    } else {
      dispatch('storeUserInfoLocal', state.user);
    }
  },
  deleteUserInfo({ commit }) {
    let user = {
      id: 32544,
      player: 0,
      show_dashboard: 0,
      token_b2c: token.free,
      tournament: 1,
      season: 1694,
      premiumAccount: false,
      userType: 0, //0, b2c - 1 gol
      accessVideos: false,
      active_time: 0, //0: no activo - 1: activo
      language: 'es',
    };
    window.localStorage.removeItem('user');
    commit('setSeasonsSelected', null);
    window.localStorage.removeItem('urlGS1');
    window.localStorage.removeItem('seasonSelected');
    window.localStorage.removeItem('tournamentSelected');
    window.localStorage.removeItem('isFromApp');
    window.localStorage.removeItem('data-search');
    commit('setPymErr', false);
    commit('profileGeneral/updateCards', [], { root: true });
    commit('profileGeneral/setCurrentPlanId', null, { root: true });
    commit('profileGeneral/setProfilePlans', [], { root: true });
    commit('setUser', user);
  },
  getUserInfoLocal({ commit }) {
    try {
      let user = window.localStorage.getItem('user');
      if (user) {
        user = JSON.parse(window.atob(user));
        commit('setUser', user);
        commit('setCurrentLanguage', user.language);
      }
      return user;
    } catch (e) {
      return null;
    }
  },
  getUserTournament({ state }) {
    try {
      return state.user.show_dashboard;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
};

const getters = {
  getIsB2CPremium(state) {
    return state.user && state.user.premiumAccount;
  },
  getIsGSUser(state) {
    return state.user && (state.user.userType === 1 || state.booleanIsGSBehavior);
  },
  getPremiumAccount(state) {
    return state.user.premiumAccount;
  },
  isGS1(state) {
    return state.isGS1;
  },
  getUserType(state) {
    return state.user.userType;
  },
  // getIsGolstats(state) {
  //   return state.user.golstats;
  // },
  showDashboard(state) {
    return !!state.user.show_dashboard;
  },
  isPlayer(state) {
    return !!(state.user && state.user.is_player);
  },
  isGoalkeeper(state) {
    return !!(state.user && state.user.is_goalkeeper);
  },
  isLoggedIn() {
    return true;
    // return Boolean(state.user.token);
  },
  getIsGolstats() {
    return 0;
  },
  getURL(state) {
    if (state.urlGS1 != '') {
      return state.urlGS1;
    } else {
      return window.localStorage.getItem('urlGS1');
    }
  },
  getUser(state) {
    return state.user;
  },
  getOpened(state) {
    return state.opened;
  },
  getTournaments(state) {
    return state.tournaments;
  },
  getTournamentSelected(state) {
    // return state.tournamentSelected;
    if (!state.tournamentSelected) {
      const tournamentSelected = window.localStorage.getItem('tournamentSelected');
      if (tournamentSelected) {
        state.tournamentSelected = Number(tournamentSelected);
      }
    }
    return Number(state.tournamentSelected);
  },
  getIsCupTournament(state) {
    const numberTournamentId = Number(state.tournamentSelected);
    const objectTournamentSelected = state.mapTournaments.get(numberTournamentId);
    return objectTournamentSelected && objectTournamentSelected.tournament_type;
  },
  getSeasons(state) {
    return state.seasons;
  },
  getSeasonSelected(state) {
    if (!state.seasonSelected) {
      const seasonSelected = window.localStorage.getItem('seasonSelected');
      if (seasonSelected) {
        state.seasonSelected = Number(seasonSelected);
      }
    }
    return Number(state.seasonSelected);
  },
  getTournamentsNameSelected(state) {
    return state.tournamentNameSelected;
  },
  getSeasonsNameSelected(state) {
    return state.seasonNameSelected;
  },
  getModal(state) {
    return state.modal;
  },
  // getPremiumAccount(state) {
  //   return state.premium;
  // },
  seasonId(state) {
    if (state.user.show_dashboard == 1) {
      return window.localStorage.getItem('seasonSelected');
    } else {
      return state.user ? state.user.season : 1535;
    }
  },
  isUserSessionLive(state) {
    return !!state.user; //? state.user.sessionExpiration >= new Date().getTime() : false;
  },
  isTournamentLogoAllowed(state) {
    return state.tournamentSelected === 1;
  },
  isNationalTournament(state) {
    return state.user ? nationalTournaments.includes(state.user.tournament) : false;
  },
  isNextGamesAllowed(state) {
    return state.user ? state.user.tournament === 1 : false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
